var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"outlined":"","tile":""}},[_c('v-card-title',[_vm._v(" Canbus Values Counter Configs ")]),_c('v-divider'),_c('counter-canbus-values-configs-list',{attrs:{"configs":_vm.canbusValuesConfig}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }